<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
  <h5 class="mb-0">{{"Invoice Details" | translate}}</h5>
  <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
    <li class="breadcrumb-item position-relative" routerLink="/">{{'Dashboard' | translate}}</li>
    <li class="breadcrumb-item position-relative" routerLink="/invoices">{{'Invoices' | translate}}</li>
    <li class="breadcrumb-item position-relative">{{'Invoice Details' | translate}}</li>
  </ol>
</div>

<div class="row">
  <!-- User details -->
  <div class="col-lg-3">
    <app-user-details [invoice]="invoice"></app-user-details>
  </div>

  <!-- Invoice details -->
  <div class="col-lg-9">
    <app-invoice-details-table [invoice]="invoice"></app-invoice-details-table>
  </div>
</div>